// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"861":"9d3e84b8","943":"205681f7"}[chunkId] + ".chunk.js";
};